// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'Chiedi a HP Nio',
      close: 'Chiudi la chat con Nio',
      open: 'Apri Chat con Nio',
      morningGreeting: "Buongiorno {0},",
      afternoonGreeting: "Buon pomeriggio {0},",
      eveningGreeting: "Buonasera {0},",
      morningGreetingGeneric: "Buongiorno,",
      afternoonGreetingGeneric: "Buon pomeriggio,",
      eveningGreetingGeneric: "Buonasera,",
      opening: "Sono Nio. Come posso aiutarti?",
      openingPrivacy: "Sono Nio.",
      pbIntro1: "Chiedimi della produttività del tuo dispositivo.",
      alertDefault: "Sono in una fase iniziale di sviluppo, quindi non posso ancora rispondere a <b>{0}</b> domande",
      intro2:  "Ecco alcune domande che potrebbero essere interessanti:",
      kzIntro1: "Chiedimi informazioni sulle tue preoccupazioni e ti risponderò con le informazioni della Knowledge Zone.",
      pbSample1: "Quanto è stato produttivo il sito ieri?",
      pbSample2: "Come posso migliorare la mia produttività?",
      pbSample3: "Quale stampante supera le altre?",
      pbSample4: "Quale substrato mi ha fatto perdere più tempo?",
      pbSample5: "Quale problema ha richiesto più tempo la scorsa settimana?",
      kzSample1: "Come posso ridurre lo spreco di substrati mantenendo la qualità e riducendo i costi?",
      kzSample2: "Quale stampante HP Indigo è la migliore per una stampa efficiente e uniforme di etichette per vini?",
      kzSample3: "Come posso ottimizzare l'utilizzo dei materiali di consumo per aumentare la produttività?",
      kzSample4: "Quali fattori chiave di sostenibilità dovrei considerare nella stampa?",
      kzSample5: "Come posso garantire la coerenza dei colori tra le mie strampanti HP Indigo 6000 e 20K?",
      feedbackTitle: "Motivo del tuo punteggio",
      feedbackPlaceholder: "Puoi spiegare in dettaglio cosa è successo?",
      fbPositive1: "I dati sono corretti",
      fbPositive2: "Ottima risposta",
      fbPositive3: "Molto dettagliata",
      fbPositive4: "La risposta era pertinente",
      fbOther: "Altro",
      fbNegative1: "Le informazioni o i dati non sono corretti",
      fbNegative2: "La risposta non ha risolto la mia domanda",
      fbNegative3: "La risposta era confusa o poco chiara",
      fbNegative4: "La risposta non era pertinente",
      feedbackSubmittedTitle: "Grazie per il feedback!",
      feedbackSubmittedDescription_Positive: "Siamo lieti di sapere che la risposta è stata utile! Il tuo feedback ci incoraggia a continuare a offrire esperienze migliori.",
      feedbackSubmittedDescription_Negative: "Ci scusiamo per qualsiasi inconveniente ciò possa aver causato. Il nostro team esaminerà le informazioni e si adopererà per correggerle. Se hai maggiori dettagli sull'errore o feedback aggiuntivo, faccelo sapere per aiutarci a migliorare.",
      ask_Placeholder: "Cosa vuoi sapere?",
      answerCopiedToClipboard: "Risposta copiata negli appunti",
      feedbackSubmitted: "Feedback inviato",
      feedbackCleared: "Feedback rimosso",
      newConversation: "Nuova chat",
      chatHistory: "Cronologia chat",
      submitQuestion: "Invia domanda",
      responseError: "Ops, sembra che si sia verificato un problema. Riprova più tardi.  Se il problema persiste, contatta il supporto.",
      responseError400: "Sembra che la tua domanda contenga caratteri imprevisti. Rimuovili per continuare.",
      responseError429: "Per favore, rallenta.  Non riesco a tenere il passo con tutte tante domande.",
      like: "Mi piace",
      dislike: "Non mi piace",
      copy: "Copia negli appunti",
      retry: "Riprova",
      contact: "Contattaci",
      contactSubject: "Problema con HP Nio",
      contactQuestion: "Domanda: {0}",
      noConversations: "Non hai conversazioni",
      startConversation: "Avvia una conversazione per visualizzare la cronologia delle tue chat qui",
      today: "Oggi",
      yesterday: "Ieri",
      privacyNotice: "Stai interagendo con una soluzione AI",
      privacy1: "Stai per interagire con una soluzione AI. Le chat potrebbero essere revisionate e utilizzate per addestrare i nostri modelli.",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "Inizia a chattare con HP Nio"
    },
    apps: {
      title: "Menu",
      externalLinks: "Esterno",
      availableApps: "Esplora",
      configure: "Personalizza",
      showApp: "Mostra",
      hideApp: "Nascondi",
      setDefault: "Imposta applicazione predefinita",
      setShortcut: "Impostare come fisso",
      removeShortcut: "Libera",
      showAllApps: "Mostra tutte le applicazioni",
      shortCutTooltip: "Vai a {0}",
      currentAccount: "Organizzazione corrente",
      goHome: "Vai alla Pagina iniziale",
      goAppHome: "Vai a pagina iniziale applicazione",
      byProvider: "di: {0}",
      quickFilter: "Trova applicazione...",
      allApps: "Tutte le applicazioni",
      recentApps: "Recente",
      externalApp: "Applicazione esterna a PrintOS",
      modeSwitcher: "Modalità scura/chiara",
      goProducts: "Esplora altre app"
    },
    panels: {
      ai: "Chiedi a HP Nio",
      notifications: "Notifiche personali",
      help: "Guida e assistenza",
      user: "Utente",
      close: "Chiudi il pannello",
      moveLeft: "Sposta a sinistra",
      moveRight: "Sposta a destra",
      maximize: "Massimizza",
      restore: "Ripristina",
    },
    user: {
      account: "Organizzazione",
      returnToHP: "Restituisci ad HP Inc.",
      myOrganization: "Organizzazione personale",
      myOrganizations: "Organizzazioni personali",
      myReports: "Rapporti personali",
      mySettings: "Le mie impostazioni",
      signOut: "Disconnetti",
      signInExplanation: "Accedere a HP PrintOS per visualizzare le notifiche e le applicazioni.",
      signIn: "Accedi",
      RCDA: "Accesso cliente",
      orphanUser: "Utente PrintOS",
      orphanContext: "Nessuna organizzazione",
      deviceUser: "Dispositivo PrintOS",
      anonymous: "Utente anonimo",
      name: "Nome",
      email: "Email",
      address: "Indirizzo",
      editUser: "Modifica account HP",
      viewPrivacy: "Visualizza l'Informativa sulla privacy"
    },
    date: {
      fewSecondsAgo: "Alcuni secondi fa",
      minuteAgo: "Un minuto fa",
      minutesAgo: "{0} minuti fa",
      hourAgo: "Un'ora fa",
      hoursAgo: "{0} ore fa",
      dayAgo: "Un giorno fa",
      daysAgo: "{0} giorni fa",
      monthAgo: "Un mese fa",
      monthsAgo: "{0} mesi fa",
      yearAgo: "Un anno fa",
      yearsAgo: "{0} anni fa",
    },
    help: {
      quickFilter: "Ricerca",
      page: "Pagina",
      app: "Applicazione",
      newFeatures: "Nuove funzioni",
      more: "Tutti",
      contactHP: "Contatta HP",
      noTopics: "Nessun argomento della guida corrispondente",
      about: "Informazioni",
      terms: "Condizioni del servizio",
      readFile: "Documento",
      stepByStepTutorial: "Esercitazione",
      goLink: "Pagina applicazione",
      viewVideo: "Video",
      goToUrl: "Link",
      other: "Altro",
      faq: "Domande frequenti",
      new: "Nuovo argomento",
      whatsNew: "Novità",
      technicalSupport: "Supporto PrintOS",
      printOSFeedback: "Feedback su PrintOS",
      conversationsWithHP: "Conversazioni con HP",
      youMayConsider: "Qualche suggerimento...",
      myKzArticles: "Articoli Knowledge Zone",
      kzServiceTopics: "{0} ({1})",
      lkcArticles: "Articoli di HP Latex Knowledge Center",
    },
    notifications: {
      noNotifications: "Nessuna notifica presente",
      viewAll: "Visualizzare tutto",
      dismiss: "Scarta",
      dismissAll: "Scarta tutto",
      subscriptions: "Impostazioni",
    },
    marketplace: {
      title: "Marketplace",
      explore: "Esplora tutto",
      featured: "In primo piano",
      slides: {
        default: {
          description: "Ottimizza PrintOS con applicazioni, estensioni e connettori premium"
        },
        oee: {
          title: "Print Beat OEE",
          description: "Favorisci l'eccellenza operativa con insight basati sui dati quasi in tempo reale",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "L'accesso a Indirgo Print Beat, Jobs, OEE e ai servizi di Print Beat richiederà un <a href = 'https: /intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target = 'blank'>abbonamento Productivity Power Pack </a> a partire dal 4 agosto.",
      partialProductivitySubscribePreEnforcement_Desc: "I dati da dispositivi non sottoscritti possono essere estratti prima di agosto.",
      partialProductivitySubscribePostEnforcement_Title: "Non tutti i tuoi dispositivi Indigo sono abbonati al Productivity Power Pack ({0}/{1})",
      partialProductivitySubscribePostEnforcement_Desc: "I dispositivi non abbonati potrebbero limitare l'esperienza con PrintOS (Print Beat, Jobs, OEE, Dashboard ecc.)",
      goToMarket_Action: "Vai al Marketplace",
      howToExtract_Action: "Come estrarre i miei dati"
    },
    focus: {
      title: "Focus",
    },
    locales: {
      "de-DE": "Tedesco",
      "en-GB": "Inglese (UK)",
      "en-US": "Inglese (USA)",
      "es-ES": "Spagnolo",
      "fr-FR": "Francese",
      "it-IT": "Italiano",
      "ja-JP": "Giapponese",
      "ko-KO": "Coreano",
      "pt-PT": "Portoghese",
      "tr-TR": "Turco",
      "zh-HANS": "Cinese (semplificato)",
      "ru-RU": "Russo",
      "TraduzioneParziale": "Traduzioni parziali",
    },
    modal: {
      ok: "OK",
      cancel: "Annulla",
    },
    combo: {
      noItems: "Nessuna corrispondenza",
    },
    nps: {
      question: "Salve {0}. Con quante probabilità consiglieresti PrintOS a un collega?",
      // In case we can't get user's display name
      questionNameless: "Con quante probabilità consiglieresti PrintOS a un collega?",
      notLikely: "Per niente probabile",
      likely: "Molto probabile",
      send: "Invia feedback",
      response: {
        detractor: "{0}, qual è una cosa che potremmo fare per migliorare la tua esperienza PrintOS? Leggiamo tutti i commenti.",
        detractorNameless: "Qual è una cosa che potremmo fare per migliorare la tua esperienza PrintOS? Leggiamo tutti i commenti.",
        passive: "{0}, facci sapere come possiamo rendere ancora migliore la tua esperienza PrintOS. Leggiamo tutti i commenti.",
        passiveNameless: "Facci sapere come possiamo rendere ancora migliore la tua esperienza PrintOS. Leggiamo tutti i commenti.",
        promoter: "{0}, siamo entusiasti di sapere che ti piace usare PrintOS! Dicci perché. Leggiamo tutti i commenti.",
        promoterNameless: "Siamo entusiasti di sapere che ti piace usare PrintOS! Dicci perché. Leggiamo tutti i commenti.",
      },
      introMorning: "Buongiorno {0}, sono Jon, il Customer Success Manager di PrintOS.",
      introMorningNameless: "Buongiorno, sono Jon, il Customer Success Manager di PrintOS.",
      introAfternoon: "Buon pomeriggio {0}, sono Jon, il Customer Success Manager di PrintOS.",
      introAfternoonNameless: "Buon pomeriggio, sono Jon, il Customer Success Manager di PrintOS.",
      introEvening: "Buona sera {0}, sono Jon, il Customer Success Manager di PrintOS.",
      introEveningNameless: "Buona sera, sono Jon, il Customer Success Manager di PrintOS.",
      intro2: "Aiutami a capire la tua esperienza con PrintOS rispondendo a questa domanda:",
      intro3: "Con quante probabilità consiglieresti PrintOS a un collega?",
      detractorResponse: "Grazie per la risposta, {0}!  Apprezziamo sia feedback positivo sia negativo.",
      detractorResponseNameless: "Grazie per la risposta!  Apprezziamo sia feedback positivo sia negativo.",
      promoterResponse: "Grazie {0}!  È bello sapere che sei entusiasta di PrintOS.  Il tuo feedback ci aiuta comunque a offrire la migliore esperienza possibile.",
      promoterResponseNameless: "Grazie!  È bello sapere che sei entusiasta di PrintOS.  Il tuo feedback ci aiuta comunque a offrire la migliore esperienza possibile.",
      response2: "Scegli un'applicazione e dicci come possiamo migliorare PrintOS per te.",
      response3: "Tutti i commenti vengono letti dal team Customer Success.  Potremmo contattarti per comprendere meglio il feedback.",
      feedbackPlaceholder: "È possibile migliorare PrintOS...",
      application: "Applicazione",
      noApplication: "PrintOS - Feedback generale"
    },
    subscription: {
      title: "Abbonamento",
      subscribe: "Abbonati ora!",
      noticeSingular: "L'abbonamento a {0} scade tra {1} giorno.",
      notice: "L'abbonamento a {0} scade tra {1} giorni.",
    },
    promotion: {
      label: "Promozione",
      title: "Avviso periodo promozionale",
      notice: "Sei in un periodo di prova per questa applicazione.",
    },
    trial: {
      label: "La prova scade a breve",
      title: "Periodo di prova",
      noticeSingular: "{0} è in periodo di prova. La prova scade tra {1} giorno.",
      notice: "{0} è in periodo di prova. La prova scade tra {1} giorni.",
    },
    subscriptionExpired: {
      label: "Abbonamento scaduto",
      title: "Abbonamento scaduto",
      notice: "L'abbonamento di {0} è scaduto.  Dopo un breve periodo di tolleranza, non sarai più in grado di accedere a questa funzionalità.",
    },
    trialExpired: {
      label: "Prova scaduta",
      title: "Periodo di prova scaduto",
      notice: "Il periodo di prova di {0} è scaduto.  Dopo un breve periodo di tolleranza, non sarai più in grado di accedere a questa funzionalità.",
    },
    hpWarning: "{0}\nSei un rappresentante HP Inc. in un'organizzazione cliente. Presta attenzione.",
    role: {
      HP_Operation: "Operazioni HP",
      HP_Sales_and_Marketing: "Personale HP a contatto con il cliente",
      SystemRoleGenesis_Admin: "Admin servizio PrintOS",
      SystemRoleGenesis_Support: "Admin HP Inc.",
      SystemRoleGenesis_R_AND_D: "R&S Genesis",
      CE_Level_1: "CE livello 1",
      CE_Level_2: "CE livello 2",
      Application_Engineer: "Tecnico applicativo",
      Ramp_Up_Engineer: "Tecnico fase di avvio",
      Support_Engineer: "Tecnico assistenza",
      Remote_Support_Engineer: "Tecnico dell'assistenza HP",
      Specialist: "Specialista",
      Certification_Centers: "Centri di certificazione",
      Supplies_and_Media_Personnel: "Addetti ai materiali di consumo e supporti",
      Supplies_and_Media_Admin: "Admin materiali di consumo e supporti",
      HP_Service: "Servizio HP",
      HP_Training: "Formazione HP",
      Admin: "Amministratore",
      Pre_Press_Operator: "Utente",
      Press_Operator: "Operatore",
      Dashboard: "Dashboard",
      Channel_Sales_and_Marketing: "Canale distributivo e marketing",
      Channel_Operation: "Operazioni Canale",
      Channel_CE_Level_1: "CE livello 1 canale",
      Channel_CE_Level_2: "CE livello 2 canale",
      HP_Read_Only: "Solo lettura HP",
      Reseller_Manager: "Reseller Manager",
      Business_Partner_Manager: "Business Partner Manager",
      Call_Center: "Call Center",
      Field_Engineer: "Tecnico sul campo",
      ThreeD_Business_Manager: "3D Business Manager",
      HPInPsp: "HP su PSP",
      ChannelInPsp: "Canale su PSP",
      GenericAdmin: "Amministratore",
      GenericUser1: "Livello utente 1",
      GenericUser2: "Livello utente 2",
      Generic_Read_Only: "Solo lettura",
      ThreeD_Care_Center: "3D Care Center",
      ThreeD_Cost_Calculator: "Costo 3D",
      Composer_External: "Accesso limitato - Gestione composizioni",
      SIM_External: "Accesso limitato - Gestione inventario materiali di consumo",
      Multiple: "Ruoli multipli"
    },
    inlineAlerts: {
      Http_429_Error: "Traffico elevato",
      Http_429_Description: "Il servizio sta riscontrando carichi anomali in questo momento. Alcune funzionalità potrebbero essere temporaneamente non disponibili. Aggiorna la pagina per riprovare",
      Http_429_Action: "Aggiorna",
      NewSubscription: "Nuovo abbonamento: {0}",
      NewSubscriptionDescription: "La tua organizzazione ha un nuovo abbonamento",
      NewSubscriptionAction: "Ulteriori informazioni",
      SubscriptionExpired: "Abbonamento scaduto: {0}",
      SubscriptionExpiredDescription: "L'abbonamento è scaduto il {0}",
      SubscriptionExpiredAction: "Visualizza l'abbonamento",
      Subscription30DayWarning: "L'abbonamento scadrà a breve: {0}",
      Subscription30DayWarningDescription: "L'abbonamento scadrà tra {0} giorni il {1}",
      Subscription30DayWarningAction: "Visualizza l'abbonamento",
      Subscription15DayWarning: "L'abbonamento scade a breve: {0}",
      Subscription15DayWarningDescription: "L'abbonamento scadrà tra {0} giorni il {1}",
      Subscription15DayWarningAction: "Visualizza l'abbonamento",
      JoinOrgRequestAccepted: "La richiesta di unirti all'organizzazione è stata accettata",
      JoinOrgRequestAcceptedDescription: "Ti è stato accordato l'accesso a <b>{0}</b>",
      JoinOrgRequestSwitch: "Apri organizzazione",
      JoinOrgRequestDenied: "La richiesta di unirti all'organizzazione è stata rifiutata",
      JoinOrgRequestDeniedDescription: "L'amministratore ha rifiutato la tua richiesta di unirti a <b>{0}</b>",
      NonHPContext: "Apri la finestra di contesto non HP",
      NonHPContextDescription: "Contesto: {0}",
      CloseContext: "Chiudi contesto"
    },
    ui: {
      Confirm: "Conferma",
      Notify: "Notifica",
      OpenImage: "Apri file immagine",
      Dismiss: "Scarta",
      CheckingContext: "Controllo del contesto...",
      LoadingContext: "Ripristino di {0}..."
    }
  }
};
